// extracted by mini-css-extract-plugin
export default {"form":"Login2Fa_form__xE1aE","input":"Login2Fa_input__+pZhS","buttonsContainer":"Login2Fa_buttonsContainer__t--rE"};